'use strict';exports.__esModule = true;var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _OMTooltip = require('./OMTooltip.scss');var styles = _interopRequireWildcard(_OMTooltip);
var _OMTooltipMobile = require('./OMTooltipMobile.scss');var mobileStyles = _interopRequireWildcard(_OMTooltipMobile);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OMTooltip = function OMTooltip(properties) {var _cx;return (
    _react2.default.createElement('div', {
        className: (0, _classnames2.default)(styles.tooltip, styles[properties.className], mobileStyles[properties.className], (_cx = {}, _cx[
        styles.rtlPosition] = properties.locale === 'he', _cx)) },


      !properties.hideCloseButton ?
      _react2.default.createElement('span', { className: (0, _classnames2.default)('icon icon-close', styles.closeBtn), onClick: properties.onClose }) :
      null,
      properties.msg));};exports.default =



OMTooltip;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMTooltip/OMTooltip.js
// module id = 563
// module chunks = 0